<template>
	<div>
		<van-popup v-model="times_show" position="bottom" :close-on-popstate="false" style="border-radius: 8px 8px 0 0;background-color: #FFFFFF;">
			<div v-if="stock_list.length>0" class="cmbc_detail_pop width_100">
				<div class="cmbc_detail_pop_1 width_100 font_size_32 color_333333 font_weight_600">请选择时间</div>
				<div class="cmbc_detail_pop_2 width_100">
					<div class="width_fit text_ellipsis2 display_start_center">
						<div v-for="(item_date,index_date) in stock_list" :key="'date'+index_date" 
						:class="[{'cmbc_detail_pop_2_dateS color_ffffff':index_date==date_index},
						{'color_333333':index_date!=date_index &&item_date.num>0},{'color_999999':index_date!=date_index &&item_date.num==0},
						'cmbc_detail_pop_2_date display_center_center text_align_center border_radius_16 ']" 
						@click="selectBookDate(item_date,index_date)">
							<div>
								<div class="font_size_32">{{item_date.date_obj.week}}</div>
								<div class="font_size_24 font_weight_600">{{item_date.date_obj.date_pioP}}</div>
							</div>
						</div>
					</div>
				</div>
				<div class="cmbc_detail_pop_3 width_100">
					<van-row gutter="5">
					  <van-col span="6" v-for="(item_time,index_time) in stock_list[date_index].slots" :key="'date'+index_time">
						  <div :class="[{'cmbc_detail_pop_3_itemS color_ffffff':index_time==time_index},{'color_333333':stock_list[date_index].num>0},
						  {'color_999999':stock_list[date_index].num==0},
						  'cmbc_detail_pop_3_item width_100 display_center_center font_size_26']" 
						  @click="selectBookTime(stock_list[date_index].num,index_time)">{{item_time}}</div>
					  </van-col>
					</van-row>
				</div>
				<div class="cmbc_detail_pop_4 width_100">
					<div @click="nextPage()" 
					:class="[{'cmbc_detail_pop_4_btnS':time_index>=0},'cmbc_detail_pop_4_btn width_100 display_center_center color_ffffff font_size_32']">确认</div>
				</div>
			</div>
		</van-popup>
	</div>
</template>

<script>
	import {
		datePrintStr
	} from "../lib/utils"
	import {
		getServiceAvailableDates
	} from '../api/api.js'
	export default {
		props: {
			goods_detail:{
				type: Object,
			},
		},
		data() {
			return {
				times_show:false,
				date_index:0,
				time_index:-1,
				stock_list:[]
			}
		},
		mounted() {},
		methods: {
			async getStockInfo(){
				this.$RCLoading.show();
				var $this=this
				// console.log(this.goods_detail);
				var params={
					serviceId:this.goods_detail.serviceId
				}
				try {
					var res=await getServiceAvailableDates(params)
					console.log(res);
					if(res.data && res.data.length>0){
						// res.data[0].num=0
						// res.data[1].num=0
						res.data.map((item)=>{
							item.date_obj=datePrintStr(item.date)
						})
					}
					$this.stock_list=res.data
					this.date_index=0
					this.time_index=-1
					$this.openTimePop()
					$this.$RCLoading.hide();
					
				} catch (error) {
					//TODO handle the exception
				}
			},
			openTimePop(){
				if(this.stock_list.length>0){
					this.times_show=true
				}
			},
			closeTimePop(){
				this.times_show=false
			},
			selectBookDate(item,index){
				if(item.num<=0){
					return
				}
				this.date_index=index
				this.time_index=-1
			},
			selectBookTime(num,index){
				console.log(num,index);
				if(num>0){
					this.time_index=index
				}
			},
			nextPage(){
				// serviceId:this.goods_detail.serviceId
				console.log(this.stock_list);
				console.log(this.date_index);
				console.log(this.time_index);
				// return
				if(this.time_index>=0){
					var params={
						service_id:this.goods_detail.serviceId,
						date:this.stock_list[this.date_index].date,
						time:this.stock_list[this.date_index].slots[this.time_index],
						max_num:this.stock_list[this.date_index].num
					}
					this.$router.push({
						name:'cmbc_cr_create_order_1',
						params:params,
					})
					this.closeTimePop()
				}
				
			}
		}
	}
</script>

<style lang="less" scoped="scoped">
	@vm_base: 1/750*100vw;
	.cmbc_detail_pop{
		padding: 30*@vm_base 0;
		padding-bottom: calc(constant(safe-area-inset-bottom) / 2 + 30*@vm_base);
		padding-bottom: calc(env(safe-area-inset-bottom) / 2 + 30*@vm_base);
		.cmbc_detail_pop_1{
			padding: 0 30*@vm_base;
		}
		.cmbc_detail_pop_2{
			overflow: hidden;
			overflow-x: auto;
			padding: 26*@vm_base 0 10*@vm_base 0;
			.cmbc_detail_pop_2_date{
				width: 120*@vm_base;
				height: 120*@vm_base;
				margin-right: 20*@vm_base;
				border:1*@vm_base solid #D9D9D9;
				&:first-child{
					margin-left: 30*@vm_base;
				}
				&:last-child{
					margin-right: 30*@vm_base;
				}
				div{
					div{
						line-height: 1.3;
					}
				}
			}
			.cmbc_detail_pop_2_dateS{
				background: linear-gradient( 35deg, #FFA662 0%, #FA7D23 100%);
				border:1*@vm_base solid transparent;
			}
		}
		.cmbc_detail_pop_3{
			margin-top: 20*@vm_base;
			padding: 0 30*@vm_base;
			min-height: 400*@vm_base;
			.cmbc_detail_pop_3_item{
				height: 64*@vm_base;
				border-radius: 10*@vm_base;
				border: 1*@vm_base solid #D9D9D9;
				margin-bottom: 10*@vm_base;
			}
			.cmbc_detail_pop_3_itemS{
				border: 1*@vm_base solid transparent;
				background: linear-gradient( 35deg, #FFA662 0%, #FA7D23 100%);
			}
		}
		.cmbc_detail_pop_4{
			padding: 0 75*@vm_base;
			.cmbc_detail_pop_4_btn{
				height: 80*@vm_base;
				background: #D9D9D9;
				border-radius:40*@vm_base;
			}
			.cmbc_detail_pop_4_btnS{
				background: linear-gradient( 233deg, #FB8027 0%, #FFA663 100%);
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/time_pop.vue